import { render, staticRenderFns } from "./DayLabel.vue?vue&type=template&id=91a65216&scoped=true&"
import script from "./DayLabel.vue?vue&type=script&lang=js&"
export * from "./DayLabel.vue?vue&type=script&lang=js&"
import style0 from "./DayLabel.vue?vue&type=style&index=0&id=91a65216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a65216",
  null
  
)

export default component.exports